import { formatCurrency } from "@/design-system/lib/format";

/**
 * How much of a prequalification's sizing this reader is allowed to see.
 *
 * 🔴 The server redacts `qualifiedAmount` to null for every caller without
 * `Prequalification.Read` and answers the remaining question with
 * `hasQualifiedAmount`. Rendering the amount alone would therefore show a
 * *sized* prequalification as blank — indistinguishable from an unsized one,
 * and the wrong answer to the only question a redacted reader still has:
 * "will linking this unblock the package?"
 *
 * Extracted because six surfaces make this same call — two candidate pickers,
 * the attempts list, the letter-override picker, and both link panels — and a
 * surface that forgot the flag would silently report "not qualified".
 */
type Sizing = {
  qualifiedAmount?: number | null;
  hasQualifiedAmount?: boolean;
};

/** The figure for a labelled field. `null` renders as the field's own empty
 *  state, which is correct only when the submission genuinely has no figure. */
export function qualifiedAmountLabel(a: Sizing): string | null {
  if (a.qualifiedAmount != null) return formatCurrency(a.qualifiedAmount);
  return a.hasQualifiedAmount ? "Restricted" : null;
}

/** The same fact as an inline clause, for captions that read as a sentence.
 *  Returns "" when there is no figure at all, so the clause disappears rather
 *  than printing an empty one. */
export function sizedClause(a: Sizing): string {
  if (a.qualifiedAmount != null) return ` · sized to ${formatCurrency(a.qualifiedAmount)}`;
  return a.hasQualifiedAmount ? " · sized (amount restricted)" : "";
}
